<template>
  <div class="animate-pulse bg-gray-100 aspect-square relative overflow-hidden group">
    <!-- Blurred Background Effect -->
    <div class="absolute inset-0 bg-gradient-to-br from-gray-200 to-gray-50 blur-sm"></div>

    <!-- Skeleton Content -->
    <div class="absolute bottom-0 left-0 right-0 p-3 bg-white/40 backdrop-blur-md border-t border-white/20 flex justify-between items-end">
      <div class="space-y-2 w-2/3">
        <div class="h-2 bg-gray-300 rounded w-full"></div>
        <div class="h-2 bg-gray-300 rounded w-1/2"></div>
      </div>
      <div class="h-4 bg-gray-300 rounded w-1/4"></div>
    </div>

    <!-- Shimmer Effect -->
    <div class="shimmer-wrapper">
      <div class="shimmer"></div>
    </div>
  </div>
</template>

<style scoped>
.shimmer-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.shimmer {
  width: 50%;
  height: 100%;
  background: linear-gradient(
    to right,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.4) 50%,
    rgba(255, 255, 255, 0) 100%
  );
  transform: skewX(-20deg);
  animation: shimmer 1.5s infinite;
}

@keyframes shimmer {
  0% {
    transform: translateX(-150%) skewX(-20deg);
  }
  100% {
    transform: translateX(250%) skewX(-20deg);
  }
}
</style>